import React, { useState } from "react";
import Select from "react-select";

const PositionFamiliesSelect = (props) => {
  const positions = [
    { value: "developer", label: "Desarrollador" },
    { value: "technical_leadership", label: "Technical Manager / Technical Lead" },
    { value: "data_and_digital_engineering", label: "Ingenieros de Datos Marketing / Transformacion Digital / Tecnologia" },
    { value: "management_and_leadership", label: "Gerente / Sub-Gerente / Jefe de Area / Lider" },
    { value: "administrative_and_support", label: "Asociado / Analista / Ejecutivo / Administrativo" },
    { value: "security", label: "Vigilante" },
    { value: "internship_and_sales", label: "Practicante / Ejecutivo Comercial BICE Ventas" }
  ];

  const [positionFamily] = useState(positions);

  const handleChangePosition = inputValue => {
    props.handleChange(inputValue, "positionFamily");
  };

  return (
    <Select
      inputId="positionFamily"
      onChange={handleChangePosition}
      options={positionFamily}
      placeholder="Seleccione una opción"
      value={positionFamily.find(
        (option) => option.value === props.value?.value
      ) || null}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
};

export default PositionFamiliesSelect;
